const transactionsDataMapper = (data, formatDate, username) => {
  const DEVOLUTION = "D";

  const isOutgoingTransfer = (destinationUsername, currentUsername) =>
    destinationUsername !== undefined &&
    destinationUsername !== currentUsername;
  const hasDevolution = (operation) =>
    operation.hasDevolution || operation.transaction_type === DEVOLUTION;
  // api does not always return negative transactions
  const formatTotal = (operation) => {
    // transfer from current acc to another one
    // or transafered returned back
    if (
      isOutgoingTransfer(
        operation.transference?.destination?.username,
        username
      ) ||
      hasDevolution(operation)
    ) {
      return parseFloat(-operation.total.amount).toFixed(2);
    }
    // transfered received or chargeback (already negative value from backend api)
    return parseFloat(operation.total.amount).toFixed(2);
  };

  const rows = data.operations.map((item) => ({
    key: item.transaction,
    detail: {
      authorization_code: item.authorization_code,
      commission: item.commission.amount,
      tip: item.tip.amount,
      fee: item.fee.amount,
      hasDevolution: item.hasDevolution,
      total: item.total.amount,
      url: item.url,
      date: new Date(item.timestamp),
      fees: item.fee_details,
      transference: item.transference,
    },
    date: formatDate(item.timestamp, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    }),
    paymentMethod: {
      cardID: item.card.type,
      cardNumber: item.card.number,
    },
    cardHolderName: item.card.holder_name,
    concept: item.reference.description, // TODO: Where the operator comes?
    sellChannel: item.payment_method,
    total: formatTotal(item, username),
    currency: item.total.currency,
    hasDevolution: hasDevolution(item),
    related: item.related?.transaction,
    type: item.type,
  }));

  return { rows };
};

export default transactionsDataMapper;
